//package imports
import React, { useEffect, useState } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Formik, useFormik } from 'formik';
import osanLogoImg from "../../assests/images/osanLogo1.webp"

//componenet imports
import CustomTextField from "../../utils/resuableComponents/CustomTextfield";
import { CustomDropdown } from "../../utils/resuableComponents/CustomDropdown";
import { getStateList, getUserType,getBankList} from "../../services/apiServices/GetServices";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { GetCityList } from "../../services/apiServices/PostServices";
import { UpdateUserApi, ValidateEmail, ResendEmailOtp, CreateUserApi } from "../../services/apiServices/PostServices";
import CustomModal from "../../utils/resuableComponents/CustomModal";
import { showToast } from "../../utils/constants/Toaster";
import { getData, removeData } from "../../utils/AsyncStorage";
import { storeData } from "../../utils/AsyncStorage";
import Loader from "../loadingScreens/Loader";


const CreateProfile = (props) => {

    const history = useHistory();
    const [statesData, setStatesData] = useState([])
    const [stateId, setStateId] = useState("")
    const [userTypeData, setUserTypeData] = useState([])
    const [userType,setUserType]=useState("")
    const [cityData, setCityData] = useState([])
    const [bankData,setBanksData]=useState([])
    const [emailModal, setEmailModal] = useState(false)
    const [email, setEmail] = useState("")
    const [buttonState, setButtonState] = useState(false)
    const [isLoader,setIsLoader]=useState(false)
    const [fromPage,setFromPage]=useState("")
    const number = props?.location?.state?.mobile_number
    const emailValue = props?.location?.state?.email
    const encrypt_id = props?.location?.state?.encrypt_id
    const { role, id } = JSON.parse(getData("userInfo") || 0);

      
     useEffect(() => {
        if(props?.location?.state?.from === "createProfile" ){
            const handleBackButton = (event) => {
                event.preventDefault(); // Prevent default behavior of the back button
                // Optionally, you can provide a message or perform other actions before preventing navigation
                // alert('Back navigation is disabled on this page.');
              };
              // Add event listener to the 'popstate' event triggered by browser navigation
              window.addEventListener('popstate', handleBackButton);
              // Cleanup function to remove event listener when component unmounts
              return () => {
                window.removeEventListener('popstate', handleBackButton);
              };
        }
     }, [props?.location?.state?.from]);

    //function to cloase
    const closeEmailModal = () => {
        setEmailModal(false)
        history.push("/customerPortal/myShares")
    }

    const handleEmailVerification = () => {
        setEmailModal(true)
        setFromPage("EmailModal")
    }
    const [initialValues, setInitialValues] = useState({
        firstName: '',
        middleName: '',
        lastName: '',
        email: emailValue || '',
        address1: '',
        address2: '',
        dematAccount:'',
        state: '',
        city: '',
        bankId:'',
        bankName:'',
        nameAsPerBankAccount:'',
        accountNumber:'',
        confirmAccountNumber:'',
        ifscCode:'',
        pincode: '',
        userType: '',
        phoneNumber: number ||'',
        checked: false
    });
    

    useEffect(() => {
        callStateslistApi()
        callUserTypelistApi()
        callBankData()
    }, []);

    useEffect(() => {
        if (stateId !== "") {
            callCitylistApi()
        }

    }, [stateId]);

    const termsAndCondtionPath = process.env.REACT_APP_TERMS_CONDTIONS

    //function to call list api
    const callStateslistApi = async () => {
        try{
            const res = await getStateList("state/1")
            if (res?.success) {
                setStatesData(res?.data)
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log("error",error)
        }
    }

        //function to call list api
        const callBankData = async () => {
            try{
                const res = await getBankList("bank")
                if (res?.success) {
                    setBanksData(res?.data)
                } else {
                    console.log("res", res?.message)
                }
            }catch(error){
                console.log("error",error)
            }
        }

    //function to call city api
    const callCitylistApi = async () => {
        try{
            const reqbody = {
                state_id: stateId
            }
            const res = await GetCityList(`city`, reqbody)
            if (res?.success) {
                const citiesWithOthers = [...res?.data, { id: 'others', name: 'Others' }];
                setCityData(citiesWithOthers)
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log("error",error)
        } 
    }

    //function to userType type api
    const callUserTypelistApi = async () => {
        try{
            const res = await getUserType("userType")
            if (res?.success) {
                setUserTypeData(res?.data)
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log("error",error)
        }
    }

    //function to handleCheckBox
    const handleChange = event => {
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            checked: !formik.values.checked,
        }));
    }

    //function to hit email verificaiton 
    const handleOnSubmitEmailVerification = async (otp) => {
        try{
            const reqbody = {
                email: email,
                otp: otp
            }
            const res = await ValidateEmail("validateEmail", reqbody);
            if (res?.success) {
             history.push("/customerPortal/myShares")
                showToast(1, "Your mail is verified")
            } else {
                showToast(3, res?.message)
            }
        }catch(error){
            console.log("error",error)
        }
    }

    //function to hit profile submit api 
    const handleProfileSubmit = async (values) => {
        // setIsLoader(true)
        const reqbody = {
            user_id:encrypt_id,
            first_name: values.firstName,
            middle_name: values.middleName,
            last_name: values.lastName,
            email: email !== "" ? email :values.email,
            address1: values.address1,
            demat_account:values.dematAccount,
            bank_id :values.bankId || null,
            name_on_bank:values.nameAsPerBankAccount || null,
            bank_account_no:values.accountNumber || null,
            bank_ifsc:values.ifscCode || null,
            state: values.state,
            city: values.city,
            post_code: values.pincode,
            phone_number:number !== "" ? number : values.phoneNumber
        }
        setEmail(values.email)
      
        try{
            const res = await UpdateUserApi("user", reqbody); //PUT Api
            let obj = {
                first_name: values.firstName,
                last_Name: values.lastName,
                role: role,
                id: id
            }
            let objs = JSON.stringify(obj);
            if (res.success) {
                await storeData("userInfo", objs);
                history.push("/customerPortal/myShares")
                // handleEmailVerification()
            } else {
                // showToast(3, res?.message)
                res?.errors.map((data) => { showToast(3, data?.msg) })
                // console.log("res",res?.errors)
            }
        }catch(error){
            console.log("error",error)
        }
    }

    //function to create userProfile 
    const handleCreateProfile = async (values) => {
        // setIsLoader(true)
        setButtonState(true)
        const reqbody = {
            first_name: values.firstName,
            middle_name: values.middleName,
            last_name: values.lastName,
            email: values.email,
            role: values.userType,
            address1: values.address1,
            address2: values.address2,
            bank_id : values.bankId || null,
            name_on_bank:values.nameAsPerBankAccount || null,
            bank_account_no:values.accountNumber || null,
            bank_ifsc:values.ifscCode || null,
            demat_account:values.dematAccount,
            state: values.state,
            city: values.city,
            post_code: values.pincode,
            phone_number: values.phoneNumber
        } 
      
         try{
            const res = await CreateUserApi("user", reqbody);
      
            if (res.success) {
                showToast(1, res?.message)
                history.push("/admin/userManagement")
            } else {
                setButtonState(false)
                
                res?.errors.map((data) => { showToast(3, data?.msg) })
            }
         }catch(error){
            console.log("error",error)
         }
    }

    //function to handle resend email_otp
    const handleResendOtp = async (values) => {
        try{
            const reqbody = {
                email: email,
            }
            const res = await ResendEmailOtp("email_otp", reqbody);
            if (res.success) {
                showToast(1, res?.message)
            } else {
                showToast(3, res?.message)
            }
        }catch(error){
            console.log("error",error)
        }
       
    }

    const {
        handleSubmit,
        setValue,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            checkbox: false,
        },
    });

    //..............handle onchange of the form field......................................................//

    const handleNameChange = event => {
        const newName = event;
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            firstName: newName,
        }));
    };

    const handleChangeNameAsBankAccount = event => {
        const cleanedValue = event.replace(/[^a-zA-Z\s]/g, '').trimStart();
        
        formik.setValues(prevValues => ({
            ...prevValues,
            nameAsPerBankAccount: cleanedValue,
        }));

       
    };

    const handleMiddleNameChange = event => {
        const newName = event;
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            middleName: newName,
        }));
    };

    const handleLastNameChange = event => {
        const newName = event;
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            lastName: newName,
        }));
    };

    const handleEmailChange = event => {
        const newEmail = event;
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            email: newEmail,
        }));
    };

    const handleAddress1Change = event => {
        
        let  address1 = event;
        if(address1.startsWith(" ")){
            address1 = ""
        }else{
            address1 = event
        }
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            address1: address1,
        }));
    };

    const handleAddress2Change = event => {
        let  address2 = event;
        if(address2.startsWith(" ")){
            address2 = ""
        }else{
            address2 = event
        }
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            address2: address2,
        }));
    }

    const handleDematAccountChange = event => {
        let dematAccountId = event 

        if(dematAccountId.startsWith(" ")  ){
          dematAccountId = ""
        }else{
            dematAccountId = event
        }      
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            dematAccount: dematAccountId,
        }));
    };

    const handleIfscCode = event => {
        let ifscCode = event 

        if(ifscCode.startsWith(" ")  ){
            ifscCode = ""
        }else{
            ifscCode = event
        }      
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            ifscCode: ifscCode,
        }));
    };

    const handleStateChange = event => {
        const state = event.target.value;
        setStateId(state?.id)
        setCityData([])
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            state: state?.id,
            city: ""
        }));
    };

    const handleUserTypeChange = event => {
        const userType = event.target.value;
        setUserType(userType?.name)

        //setStateId(event.target.value)
        formik.setValues(prevValues => ({
            ...prevValues,
            userType: userType?.id,
        }));
    };

    const handleNumberChange = event => {
        const number = event;
        //setStateId(event.target.value)
        formik.setValues(prevValues => ({
            ...prevValues,
            phoneNumber: number,
        }));
    };

    const handleCityChange = event => {
        const city = event.target.value;
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            city: city?.id,
        }));
    };

    const handleBankChange = event => {
        const bank = event.target.value;
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            bankId: bank?.id,
        }));
    };

    const handlePincodeChange = event => {
        let pincode = event;
        if(pincode.startsWith('0')){
            pincode = ""
       }else{
        pincode = pincode
       }
        if (pincode.length <= 6) {
            // Update only the 'email' field in formik values
            formik.setValues(prevValues => ({
                ...prevValues,
                pincode: pincode,
            }));
        }
    };

    const handleChangeAccountNumber = event => {
        let accountNumber = event;
            // Update only the 'email' field in formik values
            formik.setValues(prevValues => ({
                ...prevValues,
                accountNumber: accountNumber,
            }));
    };

    const  handleConfirmAccountNumber = event => {
        let confirmAccountNumber = event;
            // Update only the 'email' field in formik values
            formik.setValues(prevValues => ({
                ...prevValues,
                confirmAccountNumber: confirmAccountNumber,
            }));
    };

    const validate = values => {
        const errors = {};
        // Validate email
        if (!values.firstName) {
            errors.firstName = 'First Name Required'
        } else if (values.firstName.length < 3) {
            errors.firstName = "Please enter min 3 characters"
        } else if (!values.lastName) {
            errors.lastName = 'Last Name Required'
        } else if (values.lastName.length < 1) {
            errors.lastName = "Please enter min 1 characters"
        }
        else if (!values.userType && role === 2) {
            errors.userType = 'User Type Required';
        }
        else if (!values.phoneNumber && role === 2) {
            errors.phoneNumber = 'Phone Number Required'
        } else if (values.phoneNumber.length != 10 && role === 2) {
            errors.phoneNumber = 'Invalid Number'
        }
        else if (!values.email) {
            errors.email = 'Email Required';
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
            errors.email = 'Invalid email address';
        } else if (!values.state) {
            errors.state = 'State Required';
        } else if (!values.city) {
            errors.city = 'City Required';
        } else if (!values.pincode) {
            errors.pincode = 'Pincode Required'
        } else if (values.pincode.length < 6) {
            errors.pincode = 'Please enter valid 6 digit pincode'
        }
         else if (!values.address1) {
            errors.address1 = 'Address Required'
        } else if (values.address1.length < 3) {
            errors.address1 = "Please enter min 3 characters"
        } else if (values.dematAccount.length > 1 && values.dematAccount.length < 16) {
            errors.dematAccount = "Invalid demat account number"
        }
        // else if (!values.bankId && userType !== "ADMIN") {
        //     errors.bankName = "Please Select the bank"
        // }
        // else if (!values.nameAsPerBankAccount  && userType !== "ADMIN") {
        //     errors.nameAsPerBankAccount = "Please enter name as per the bank records"
        // }
        else if ((values.nameAsPerBankAccount !== "" && values.nameAsPerBankAccount.length < 3)&& userType !== "ADMIN") {
            errors.nameAsPerBankAccount = "Please enter min 3 characters"
        }
        // else if (!values.accountNumber   && userType !== "ADMIN") {
        //     errors.accountNumber = "Please enter the bank account number"
        // }
        else if ((values.accountNumber.length < 9 || values.accountNumber.length > 18) && values.accountNumber !== "" && userType !== "ADMIN") {
            errors.accountNumber = "Please enter valid account number"
        }
        // else if (!values.confirmAccountNumber  && userType !== "ADMIN") {
        //     errors.confirmAccountNumber = "Please enter the above account number for confirmation"
        // }
        else if ((values.confirmAccountNumber !== values.accountNumber) && userType !== "ADMIN") {
            errors.confirmAccountNumber = "Number does'nt matches the above account number"
        }
        // else if (!values.ifscCode && userType !== "ADMIN") {
        //     errors.ifscCode = "Please enter the IFSC Code"
        // }
        else if ((values.ifscCode.length !== 11 && values.ifscCode !== "") && userType !== "ADMIN") {
            errors.ifscCode = "Invalid IFSC Code"
        }
        else if (values.checked === false && role === 3) {
            errors.checked = "Please select the check box"
        }
        return errors;
    };

    //function to handle on click of space submit
    const handleKeyDown = (event) => {
        // Check if the pressed key is the space key and if the submit button is focused
        if (event.key === ' ' || event.key === 'Spacebar') {
            const submitButton = document.activeElement;
            if (submitButton && submitButton.type === 'submit') {
                // Prevent the default action (form submission) when the space key is pressed
                event.preventDefault();
            }
        }
    };

    const formik = useFormik({
        initialValues: initialValues,
        validate,

        onSubmit: values => {

            {
                role === 2 ?
                    handleCreateProfile(values) :
                    handleProfileSubmit(values)
            }

            // Handle form submission
            // history.push("/customerPortal/clientDashboard")
            // resetForm();
        },

    });


    
    const isFormFilled = () => {
        // Custom validation function to check if all required fields are filled
        if (role === 3) {
            return formik.values?.firstName !== '' && formik.values?.lastName != '' && (formik.values?.email != ''|| emailValue !== '' )&& (formik.values.phoneNumber != '' || number !== '' ) && formik.values?.address1 != '' && formik.values.pincode != '' && formik.values.state != '' && formik.values.city != '' && formik.values.checked && (formik.values.dematAccount === "" || formik.values.dematAccount.length === 16) 
        } else if (userType === "ADMIN") {
            return formik.values?.firstName !== '' && formik.values?.lastName != '' && formik.values?.email != '' && formik.values?.address1 != '' && formik.values.pincode != '' && formik.values.pincode.length === 6 && formik.values.state != '' && formik.values.city != '' && formik.values.phoneNumber != '' && formik.values.phoneNumber.length === 10 && formik.values.userType !== '' && (formik.values.dematAccount === "" || formik.values.dematAccount.length === 16)
        }else{
             return formik.values?.firstName !== '' && formik.values?.lastName != '' && formik.values?.email != '' && formik.values?.address1 != '' && formik.values.pincode != '' && formik.values.pincode.length === 6 && formik.values.state != '' && formik.values.city != '' && formik.values.phoneNumber != '' && formik.values.phoneNumber.length === 10 && formik.values.userType !== '' && (formik.values.dematAccount === "" || formik.values.dematAccount.length === 16) 
        }
    };

    //function to handle back navigation 
    const handleBackNavigation = () => {
        removeData("userInfo")
        removeData("accessToken")
        history.push({
            pathname : '/login',
            // state :{
            // mobile_number : mobileNumber
            // }
            }
             );
    }
     //function to call city api again
    const handleCityApi = () => {
        callCitylistApi()
        formik.setValues(prevValues => ({
            ...prevValues,
            city: "",
        }));
    }
    return (
        <div class="container-fluid p-0 ">
            {isLoader ? <Loader/> : null}
            <form onKeyDown={handleKeyDown} onSubmit={formik.handleSubmit} autoComplete="off">
                <div class="d-flex flex-column col-12">
                    <div class="d-flex col-md-12 justify-content-center align-items-center">
                    {
                            role === 2 ?
                              null
                                :
                          <div class="col-md-2 align-self-start">
                            <img src={osanLogoImg} class="img-fluid logoCss mx-4 my-2" alt="osanLogo" />
                        </div>
                        }
                        
                        <div class={role === 2 ? "col-md-12 mx-2 text-center": "col-md-8 text-center"}>
                            <h1>Create Profile</h1>
                        </div>
                        {
                            role === 2 ?
                            null :
                            <div class="col-md-2">
                        </div>

                        }
                        
                    </div>
                    <div class="d-flex  col-md-12 justify-content-around  my-2 flex-wrap">
                        <div class="col-md-3 mx-1  my-1">
                            <CustomTextField
                                control={control}
                                header={"First Name *"}
                                name="Name"
                                size="small"
                                value={formik.values.firstName.trimStart()}
                                placeholder={"First Name"}
                                inputProps={{
                                    min: 1,
                                    maxLength: 30,
                                    style: {
                                        height: "28px",
                                    }
                                }}
                                error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                                helperText={formik.touched.firstName ? formik.errors.firstName : ''}
                                InputProps={{ sx: { borderRadius: "12px" } }}
                                onChange={(e) => {
                                    const result = e.replace(/[^A-Za-z]/g, "");
                                    handleNameChange(result)
                                }}
                            />
                        </div>
                        <div class="col-md-3 mx-1  my-1">
                            <CustomTextField
                                control={control}
                                header={"Last Name *"}
                                name="LastName"
                                size="small"
                                value={formik.values.lastName.trimStart()}
                                placeholder={"Last Name"}
                                inputProps={{
                                    min: 1,
                                    maxLength: 30, style: {
                                        height: "28px",
                                    }
                                }}
                                error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                                helperText={formik.touched.lastName ? formik.errors.lastName : ''}
                                InputProps={{ sx: { borderRadius: "12px" } }}
                                onChange={(e) => {
                                    const result = e.replace(/[^A-Za-z]/g, "");
                                    // setMobileNumber(result);
                                    handleLastNameChange(result)
                                }}
                            />
                        </div>

                        {
                            role === 2 ?
                                <div class="col-md-3 mx-1 my-1">
                                    <div class="d-flex ">
                                        <label class="fw-normal">
                                            User Type *
                                        </label>
                                    </div>
                                    <CustomDropdown data={userTypeData}
                                        onChange={(e) => {
                                            handleUserTypeChange(e)
                                        }}
                                        error={formik.touched.userType && Boolean(formik.errors.userType)}
                                        helperText={formik.touched.userType ? formik.errors.userType : ''}
                                        value={formik.values.userType}
                                        name="User Type"
                                        height={"44px"}

                                    />
                                </div>
                                :
                                null
                        }
                        {
                             number === "" || number === undefined || number === null ?
                                <div class="col-md-3 mx-1  my-1">
                                    <CustomTextField
                                        control={control}
                                        header={"Phone number *"}
                                        type={"tel"}
                                        name="Phone number"
                                        size="small"
                                        value={formik.values.phoneNumber.trimStart()}
                                        placeholder={"Phone number"}
                                        inputProps={{
                                            min: 10,
                                            maxLength: 10, style: {
                                                height: "28px",
                                            }
                                        }}
                                        error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
                                        helperText={formik.touched.phoneNumber ? formik.errors.phoneNumber : ''}
                                        InputProps={{ sx: { borderRadius: "12px" } }}
                                        onChange={(e) => {
                                            const result = e.replace(/[^0-9]/g, '');
                                            // setMobileNumber(result);
                                            handleNumberChange(result)
                                        }}
                                    />
                                </div>
                                :
                                null
                        }

                        {
                             emailValue === "" || emailValue === undefined || emailValue === null  ?
                             <div class="col-md-3 mx-1  my-1">
                            <CustomTextField
                                control={control}
                                header={"Email *"}
                                name="email"
                                size="small"
                                value={formik.values.email.trimStart()}
                                placeholder={"Email"}
                                inputProps={{
                                    min: 3,
                                    maxLength: 50, style: {
                                        height: "28px",
                                    }
                                }}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email ? formik.errors.email : ''}
                                InputProps={{ sx: { borderRadius: "12px" } }}
                                onChange={(e) => {
                                    handleEmailChange(e)
                                }}
                            />
                        </div>
                        :
                        null
                        }
                        
                       
                        <div class="col-md-3 mx-1 my-1">
                            <div class="d-flex ">
                                <label class="fw-normal">
                                    State *
                                </label>
                            </div>
                            <CustomDropdown data={statesData}
                                onChange={(e) => {
                                    handleStateChange(e)
                                }}
                                error={formik.touched.state && Boolean(formik.errors.state)}
                                helperText={formik.touched.state ? formik.errors.state : ''}
                                value={formik.values.state}
                                name="state"
                                height={"44px"}
                                placeholder="State"
                            />
                        </div>
                        <div class="col-md-3 mx-1 my-1">
                            <div class="d-flex ">
                                <label class="fw-normal">
                                    City *
                                </label>
                            </div>
                            <CustomDropdown data={cityData}
                                onChange={(e) => {
                                    handleCityChange(e)
                                }}
                                error={formik.touched.city && Boolean(formik.errors.city)}
                                helperText={formik.touched.city ? formik.errors.city : ''}
                                value={formik.values.city}
                                name="city"
                                height={"44px"}
                                callApi={handleCityApi}
                                stateId={stateId}
                            />
                        </div>
                        <div class="col-md-3 mx-1  my-1">
                            <CustomTextField
                                control={control}
                                header={"Pincode *"}
                                type={"tel"}
                                name="pincode"
                                size="small"
                                value={formik.values.pincode.trimStart()}
                                placeholder={"Enter your Pincode"}
                                inputProps={{
                                    min: 6,
                                    maxLength: 6, style: {
                                        height: "28px",
                                    }
                                }}
                                error={formik.touched.pincode && Boolean(formik.errors.pincode)}
                                helperText={formik.touched.pincode ? formik.errors.pincode : ''}
                                InputProps={{ sx: { borderRadius: "12px" } }}
                                onChange={(e) => {
                                    const result = e.replace(/[^0-9]/g, '');
                                    // setMobileNumber(result);
                                    handlePincodeChange(result)
                                }}
                            />
                        </div>
                        <div class="col-md-3 mx-1  mt-1">
                            <CustomTextField
                                control={control}
                                header={"Address *"}
                                name="address1"
                                size="small"
                                value={formik.values.address1.trimStart()}
                                placeholder={"Door no, Floor, Apartment's name"}
                                inputProps={{
                                    min: 3,
                                    maxLength: 250,
                                }}
                                multiline={true}
                                rows={2}
                                error={formik.touched.address1 && Boolean(formik.errors.address1)}
                                helperText={formik.touched.address1 ? formik.errors.address1 : ''}
                                InputProps={{ sx: { borderRadius: "12px" } }}
                                onChange={(e) => {
                                    const result = e.replace(/\D/g, "");
                                    // setMobileNumber(result);
                                    handleAddress1Change(e)
                                }}
                            />
                        </div>
                        <div class="col-md-3 mx-1  my-1">
                            <CustomTextField
                                control={control}
                                header={"Demat Account"}
                                name="Demat Account"
                                size="small"
                                value={formik.values.dematAccount.trimStart()}
                                placeholder={"Demat Account"}
                                multiline={false}
                                //rows={3}
                                inputProps={{
                                    min: 16,
                                    maxLength: 16,
                                    style: {
                                        height: "28px",
                                    }
                                }}
                                error={formik.touched.dematAccount && Boolean(formik.errors.dematAccount)}
                                helperText={formik.touched.dematAccount ? formik.errors.dematAccount : ''}
                                InputProps={{ sx: { borderRadius: "12px" } }}
                                onChange={(e) => {
                                    const result = e.replace(" ", "");
                                    // setMobileNumber(result);
                                    handleDematAccountChange(result.toUpperCase())
                                }}
                            />
                        </div>
                       {
                        userType !== "ADMIN" ?
                        <>
                        <div class="col-md-3 mx-1 my-1">
                            <div class="d-flex ">
                                <label class="fw-normal">
                                    Select Bank 
                                </label>
                            </div>
                            <CustomDropdown data={bankData}
                                onChange={(e) => {
                                    handleBankChange(e)
                                }}
                                error={formik.touched.bankId && Boolean(formik.errors.bankId)}
                                helperText={formik.touched.bankId ? formik.errors.bankId : ''}
                                value={formik.values.bankId}
                                name="bankName"
                                fromName="bankName"
                                height={"44px"}
                            />
                        </div>
                        <div class="col-md-3 mx-1  my-1">
                            <CustomTextField
                                control={control}
                                header={"Name as per the bank records "}
                                name="nameAsPerBankAccount"
                                size="small"
                                value={formik.values.nameAsPerBankAccount.trimStart()}
                                placeholder={"Name as per the bank records"}
                                inputProps={{
                                    min: 1,
                                    maxLength: 30,
                                    style: {
                                        height: "28px",
                                    }
                                }}
                                error={formik.touched.nameAsPerBankAccount && Boolean(formik.errors.nameAsPerBankAccount)}
                                helperText={formik.touched.nameAsPerBankAccount ? formik.errors.nameAsPerBankAccount : ''}
                                InputProps={{ sx: { borderRadius: "12px" } }}
                                onChange={(e) => {
                                    const result = e.replace(/[^A-Za-z]/g, "");
                                    handleChangeNameAsBankAccount(e)
                                }}
                            />
                        </div>
                        <div class="col-md-3 mx-1  my-1">
                            <CustomTextField
                                control={control}
                                header={"Account Number "}
                                type={"tel"}
                                name="Account Number"
                                size="small"
                                value={formik.values.accountNumber.trimStart()}
                                placeholder={"Account Number"}
                                inputProps={{
                                    min: 9,
                                    maxLength: 18, style: {
                                        height: "28px",
                                    }
                                }}
                                error={formik.touched.accountNumber && Boolean(formik.errors.accountNumber)}
                                helperText={formik.touched.accountNumber ? formik.errors.accountNumber : ''}
                                InputProps={{ sx: { borderRadius: "12px" } }}
                                onChange={(e) => {
                                    const result = e.replace(/[^0-9]/g, '');
                                    // setMobileNumber(result);
                                    handleChangeAccountNumber(result)
                                }}
                            />
                        </div>
                        <div class="col-md-3 mx-1  my-1">
                            <CustomTextField
                                control={control}
                                header={"Confirm Account Number "}
                                type={"tel"}
                                name="Confirm Account Number"
                                size="small"
                                value={formik.values.confirmAccountNumber.trimStart()}
                                placeholder={"Confirm Account Number"}
                                inputProps={{
                                    min: 9,
                                    maxLength: 18, style: {
                                        height: "28px",
                                    }
                                }}
                                error={formik.touched.confirmAccountNumber && Boolean(formik.errors.confirmAccountNumber)}
                                helperText={formik.touched.confirmAccountNumber ? formik.errors.confirmAccountNumber : ''}
                                InputProps={{ sx: { borderRadius: "12px" } }}
                                onChange={(e) => {
                                    const result = e.replace(/[^0-9]/g, '');
                                    // setMobileNumber(result);
                                    handleConfirmAccountNumber(result)
                                }}
                            />
                        </div>
                        <div class="col-md-3 mx-1  my-1">
                            <CustomTextField
                                control={control}
                                header={"IFSC Code "}
                                name="IFSC Code"
                                size="small"
                                value={formik.values.ifscCode.trimStart()}
                                placeholder={"IFSC Code"}
                                multiline={false}
                                //rows={3}
                                inputProps={{
                                    min: 11,
                                    maxLength: 11,
                                    style: {
                                        height: "28px",
                                    }
                                }}
                                error={formik.touched.ifscCode && Boolean(formik.errors.ifscCode)}
                                helperText={formik.touched.ifscCode ? formik.errors.ifscCode : ''}
                                InputProps={{ sx: { borderRadius: "12px" } }}
                                onChange={(e) => {
                                    const result = e.replace(" ", "");
                                    // setMobileNumber(result);
                                    handleIfscCode(result.toUpperCase())
                                }}
                            />
                        </div>
                        </> 
                        :
                        null

                       }
                        
                    </div>
                    {
                        role === 3 ?
                            <>
                                <div class="d-flex flex-row mt-2 form-check align-self-center ">
                                    <div>
                                        <input
                                            type="checkbox"
                                            checked={formik.values.agreeTerms}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <label class="form-check-label mx-2" for="exampleCheck1">I have read & agree to the  <a href={termsAndCondtionPath} class="text-decoration-none previewColor " target="_blank">
                                        <span >Terms & Conditions</span>
                                    </a>   </label>
                                </div>
                                <div class="d-flex align-self-center m-0">
                                    {formik.touched.checked && formik.errors.checked && (
                                        <h6 class="text-danger ">{formik.errors.checked}</h6>
                                    )}
                                </div>
                            </>
                            :
                            null
                    }
                    {
                        role === 3 ? 
                        <div class="text-center mt-4 ">
                        <h4 class="fs-5 m-0">
                            <span class="cursorPointer gap-2" onClick={() => handleBackNavigation()}>
                                <FontAwesomeIcon icon={faChevronLeft} />
                                <span class="mx-2 paraColor" > Back To Log In</span>
                            </span>
                        </h4>
                    </div>
                    :
                    null
                    }
                    <CustomModal
                        close={closeEmailModal}
                        open={emailModal}
                        emailAction={handleOnSubmitEmailVerification}
                        from={fromPage}
                        resendOtp={handleResendOtp}
                    />
                    <div class="align-self-center text-center my-2 pt-1">
                        <button type="submit" variant="contained" class={isFormFilled() ? "primaryButton" : "disabledButton"} disabled={buttonState === false ? false : true} >
                            Submit
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}
export default CreateProfile